var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkUsedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22.6667H9.33333C7.56522 22.6667 5.86953 21.9643 4.61929 20.714C3.36905 19.4638 2.66667 17.7681 2.66667 16C2.66667 14.2319 3.36905 12.5362 4.61929 11.286C5.86953 10.0357 7.56522 9.33333 9.33333 9.33333H12",
    stroke: "#2B7FFF",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 9.33333H22.6667C24.4348 9.33333 26.1305 10.0357 27.3807 11.286C28.631 12.5362 29.3333 14.2319 29.3333 16C29.3333 17.7681 28.631 19.4638 27.3807 20.714C26.1305 21.9643 24.4348 22.6667 22.6667 22.6667H20",
    stroke: "#2B7FFF",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6667 16H21.3333",
    stroke: "#2B7FFF",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkUsedIcon);
export default __webpack_public_path__ + "static/media/link-used-icon.a6f19c5ecc21c3ce13bdb1e8474e6a5a.svg";
export { ForwardRef as ReactComponent };